import { render } from "./IconBase.vue?vue&type=template&id=5d76562a"
import script from "./IconBase.vue?vue&type=script&lang=ts"
export * from "./IconBase.vue?vue&type=script&lang=ts"

import "./IconBase.vue?vue&type=style&index=0&id=5d76562a&lang=stylus"
script.render = render

export default script